import Type4 from "./tabType4";

export default Type4;
